import React from 'react'

interface EditorModeContextValue {
  editorFocused: boolean
  readOnly: boolean
}

// Context is used instead of blockProps so that embedded atomic block components
// (EmbeddedDashboard, EmbeddedIframe) receive live updates when editorFocused or readOnly changes.
// Draft.js's DraftEditorBlock.shouldComponentUpdate ignores blockRendererFn changes, so prop
// updates are silently dropped unless the content block itself changes — causing a stale-props
// race condition. Context propagation bypasses shouldComponentUpdate entirely.
export const EditorModeContext = React.createContext<EditorModeContextValue>({
  editorFocused: false,
  readOnly: true
})
